import classes from './BlockTimes.module.css';
import { useEffect } from 'react';
import ErrorMessage from '../StudioErstellen/ErrorMessage';
import { useTimeBlockingLogic } from '../../hooks/calendar/useTimeBlockingLogic';
import { getBerlinTodayDateString } from '../../util/bookingDateTime';

export const BlockTimes = ({ 
        createBlockedTime,
        loading,
        error: blockedTimesError,
        studioId, 
        bookingData, 
        onSave,
        blockedTimes,
        deleteBlockedTime
    }) => {

    const {
        title,
        setTitle,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        startTime,
        setStartTime,
        endTime,
        setEndTime,
        isFullDay,
        setIsFullDay,
        error,
        setError,
        isLoading,
        handleCreateBlockedTime
    } = useTimeBlockingLogic(
        studioId,
        bookingData,
        blockedTimes,
        createBlockedTime,
        deleteBlockedTime
    );

    useEffect(() => {
        if (blockedTimesError) {
            setError(blockedTimesError.message || "Fehler beim Verwalten der blockierten Zeiträume");
        }
    }, [blockedTimesError, setError]);

    const clickedFullDay = () => {
        setIsFullDay(!isFullDay);
        setStartTime("00:00");
        setEndTime("23:59");
    }

    const handleTitleChange = (e) => setTitle(e.target.value);
    const handleStartDateChange = (e) => setStartDate(e.target.value);
    const handleEndDateChange = (e) => setEndDate(e.target.value);
    const handleStartTimeChange = (e) => setStartTime(e.target.value);
    const handleEndTimeChange = (e) => setEndTime(e.target.value);

    const availableStartTimes = [
        { time: "00:00", isAvailable: true },
        { time: "01:00", isAvailable: true },
        { time: "02:00", isAvailable: true },
        { time: "03:00", isAvailable: true },
        { time: "04:00", isAvailable: true },
        { time: "05:00", isAvailable: true },
        { time: "06:00", isAvailable: true },
        { time: "07:00", isAvailable: true },
        { time: "08:00", isAvailable: true },
        { time: "09:00", isAvailable: true },
        { time: "10:00", isAvailable: true },
        { time: "11:00", isAvailable: true },
        { time: "12:00", isAvailable: true },
        { time: "13:00", isAvailable: true },
        { time: "14:00", isAvailable: true },
        { time: "15:00", isAvailable: true },
        { time: "16:00", isAvailable: true },
        { time: "17:00", isAvailable: true },
        { time: "18:00", isAvailable: true },
        { time: "19:00", isAvailable: true },
        { time: "20:00", isAvailable: true },
        { time: "21:00", isAvailable: true },
        { time: "22:00", isAvailable: true },
        { time: "23:59", isAvailable: true },
    ]

    return (
        <div className={classes.container}>
            <div className={classes.scrollBody}>
            <input 
                className={`regularLarge ${classes.titleInput}`} 
                type="text" 
                placeholder="Titel (optional)" 
                value={title}
                onChange={handleTitleChange}    
            />
            <div className={classes.wholeDayContainer}>
                <span className="regularMiddle">Ganztägig</span>
                <div className={classes.switchContainer}>
                    <label className={classes.switch}>
                        <input type="checkbox" onClick={clickedFullDay} />
                        <span className={classes.slider}></span>
                    </label>
                </div>
            </div>
            <div className={classes.wholeDayContainer}>
                <span className="regularMiddle">Beginn</span>
                <div className={classes.inputsContainer}>
                    <input 
                        className={`regularMiddle ${classes.dateInput}`} 
                        type="date" 
                        min={getBerlinTodayDateString()}
                        value={startDate}
                        onChange={handleStartDateChange}
                    />
                    {!isFullDay && (
                        <div className={classes.timeSelectionItem}>
                            <span 
                                className={classes.timeSelectionText} 
                            >
                                {startTime || "09:00"}
                            </span>
                            <select 
                                className={classes.timeInput}
                                onChange={handleStartTimeChange}
                                value={startTime || ""}
                            >
                                {availableStartTimes.map(({ time, isAvailable }) => (
                                    <option 
                                        key={time} 
                                        value={time}
                                        style={{ color: isAvailable ? 'var(--dark-grey)' : 'var(--grey-2)' }}
                                    >
                                        {time}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>
            </div>
            <div className={classes.wholeDayContainer}>
                <span className="regularMiddle">Ende</span>
                <div className={classes.inputsContainer}>
                    <input 
                        className={`regularMiddle ${classes.dateInput}`} 
                        type="date" 
                        min={startDate}
                        value={endDate}
                        onChange={handleEndDateChange}
                    />
                    {!isFullDay && (
                        <div className={classes.timeSelectionItem}>
                            <span className={classes.timeSelectionText}>
                                {endTime || "09:00"}
                            </span>
                            <select 
                                className={classes.timeInput}
                                onChange={handleEndTimeChange}
                                value={endTime || ""}
                            >
                                {availableStartTimes.map(({ time, isAvailable }) => (
                                    <option 
                                        key={time} 
                                        value={time}
                                        style={{ color: isAvailable ? 'var(--dark-grey)' : 'var(--grey-2)' }}
                                    >
                                        {time}
                                    </option>
                                ))}
                          </select>
                        </div>
                    )}
                </div>
            </div>
            
            {error && <div className={classes.errorContainer}>
                <ErrorMessage>{error}</ErrorMessage>
            </div>}
            </div>

            <footer className={classes.blockTimeModalFooter}>
                <button 
                    className={`mediumLarge ${classes.blockButton}`}
                    onClick={() => handleCreateBlockedTime(onSave)}
                    disabled={isLoading || loading}
                >
                    {isLoading ? "Wird blockiert..." : "Blockieren"}
                </button>
            </footer>
        </div>
    );
};

export default BlockTimes;